import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    divider: {
        borderColor: 'var(--color-gray-200)',
        margin: '0 -8px',
    },

    accordionContainer: {
        border: '1px solid var(--color-gray-200)',
        overflow: 'hidden',
        borderRadius: '12px',
        padding: '0px',
        boxShadow: '0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A',

        [theme.breakpoints.down('576')]: {
            borderRadius: '8px',
        },
    },

    accordionRoot: {
        boxShadow: 'none',
        border: 'none',
        padding: '8px',

        '&.MuiAccordion-root': {
            borderRadius: '12px',
        },

        '&.MuiAccordion-root::before': {
            display: 'none',
        },

        '&.Mui-expanded': {
            margin: '0',
        },

        [theme.breakpoints.down('576')]: {
            padding: '0',
        },
    },

    expandIcon: {
        width: '24px',
        height: '24px',
        color: 'var(--color-new-brand-gray-800)',
        flexShrink: 0,

        [theme.breakpoints.down('576')]: {
            width: '18px',
            height: '18px',
        },
    },

    mainAccordionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
    },

    mainAccordionHeaderTitle: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-lg)',
        fontWeight: '500',
        lineHeight: '28px',
        color: 'var(--color-new-brand-gray-900)',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',

        [theme.breakpoints.down('576')]: {
            fontSize: '14px',
            lineHeight: '20px',
            gap: '10px',

            '& svg': {
                maxHeight: '18px',
                width: 'auto',
            },
        },
    },

    mainAccordionHeaderSubtitle: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: '400',
        lineHeight: '20px',
        color: 'var(--color-gray-500)',
        whiteSpace: 'nowrap',
        marginRight: '12px',

        [theme.breakpoints.down('576')]: {
            fontSize: '12px',
            lineHeight: '17px',
        },
    },

    accordionDetails: {
        display: 'block',
        padding: '0px',
    },

    mainHeaderIcon: {
        height: '24px',
        width: '24px',
        color: '#231F20',

        [theme.breakpoints.down('600')]: {
            height: '20px',
            width: '20px',
        },
    },

    //  Sub Accordion

    subAccordionRoot: {
        width: 'auto',
        boxShadow: 'none',
        border: 'none',
        padding: '0px',

        '&.MuiAccordion-root': {
            borderRadius: '12px',
            padding: '0',
        },

        '&.MuiAccordion-root::before': {
            display: 'none',
        },
    },

    subAccordionSummary: {
        '& .MuiAccordionSummary-content': {
            margin: '18px 0',
        },
        [theme.breakpoints.down('576')]: {
            alignItems: 'flex-start',
            padding: '0 12px',

            '& .MuiAccordionSummary-content': {
                margin: '12px 0',
                alignItems: 'flex-start',
                gap: '8px',
            },

            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '12px 0',
            },

            '& .MuiAccordionSummary-expandIconWrapper': {
                marginTop: '14px',
                alignSelf: 'flex-start',
            },
        },
    },

    subAccordionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        marginLeft: '28px',

        '& svg': {
            flexShrink: 0,
        },

        [theme.breakpoints.down('576')]: {
            marginLeft: '16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            width: 'auto',
            flex: 1,
            minWidth: 0,
        },
    },

    subAccordionHeaderTitle: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-md)',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'var(--color-new-brand-gray-900)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',

        [theme.breakpoints.down('576')]: {
            fontSize: '14px',
            lineHeight: '20px',
            alignItems: 'flex-start',
            color: '#374151',
        },
    },

    subAccordionHeaderSubtitle: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: '400',
        lineHeight: '24px',
        color: '#667085',
    },

    subTitleCompleted: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: '400',
        lineHeight: '20px',
        color: '#039855',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        marginRight: '12px',

        [theme.breakpoints.down('576')]: {
            fontSize: '12px',
            lineHeight: '17px',
        },
    },

    mainSubHeaderIcon: {
        width: '20px',
        height: '20px',
        color: '#231F20',

        [theme.breakpoints.down('576')]: {
            width: '14px',
            height: '14px',
        },
    },

    success: {
        color: 'var(--color-success)',
    },

    subAccordionDetailsText: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: '400',
        lineHeight: '24px',
        color: 'var(--color-new-brand-gray-900)',
        whiteSpace: 'pre-line',
        maxWidth: '70%',

        [theme.breakpoints.down('768')]: {
            maxWidth: '100%',
        },

        [theme.breakpoints.down('576')]: {
            fontSize: 'var(--font-size-xs)',
            lineHeight: '16px',
            maxWidth: 'none',
        },

        '& video': {
            width: '100%',
            height: 'auto',
            marginTop: '16px',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
        },
    },

    subAccordionDetailsContainer: {
        padding: '0 0 0 56px ',

        [theme.breakpoints.down('576')]: {
            padding: '4px 12px 12px 40px',
        },
    },

    subAccordionDetailsSubContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '16px',
        width: '85%',

        [theme.breakpoints.down('768')]: {
            width: '100%',
        },

        [theme.breakpoints.down('576')]: {
            width: '100%',
        },
    },

    subContentItem: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        alignItems: 'flex-start',
        justifyContent: 'space-between',

        [theme.breakpoints.down('576')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
        },
    },

    subContentText: {
        fontFamily: 'var(--font-rubik)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: '400',
        lineHeight: '24px',
        color: 'var(--color-new-brand-gray-900)',
        maxWidth: '70%',

        [theme.breakpoints.down('576')]: {
            fontSize: '12px',
            lineHeight: '17px',
            maxWidth: 'none',
        },
    },
}));

export default useStyles;
